import React from "react";
import { Upload, Button, Typography, Progress } from "antd";
import { UploadOutlined, DeleteOutlined, FileOutlined } from "@ant-design/icons";
import { FileDetails, FileImage, UploadContainer } from "./styles";
import { FileUploadComponentProps } from "./constants";
import { useFileUpload } from "./useFileUpload";

export type { FileData } from "./constants";

const FileUploadComponent = ({
	title,
	style,
	isRequired = false,
	onChange,
	placeholder = "Dosya seçin",
	isDisabled,
	size = "large",
	readonly = false,
	dimensions,
	fileSize,
	fileSizeText,
	format,
	defaultValue,
	multiple = false
}: FileUploadComponentProps) => {
	const {
		fileList,
		uploadProgress,
		allowedExtensions,
		beforeUpload,
		handleRemove,
		handleRemoveAll,
	} = useFileUpload({ fileSize, fileSizeText, format, dimensions, multiple, defaultValue, onChange });

	return (
		<UploadContainer style={style}>
			{title && (
				<Typography.Title level={5} style={{ color: "#2e333e" }}>
					{title}
					{isRequired && <span style={{ color: "red" }}>&nbsp;*</span>}
				</Typography.Title>
			)}
			<Typography.Paragraph>
				Maksimum dosya boyutu: {fileSizeText}.<br /> Desteklenen formatlar: {format}.
				{dimensions && <><br /> Görsel ölçüleri: {dimensions}</>}
			</Typography.Paragraph>
			<Upload
				beforeUpload={beforeUpload}
				disabled={isDisabled || readonly}
				showUploadList={false}
				multiple={multiple}
				accept={allowedExtensions.join(",")}
				style={{ cursor: readonly ? "not-allowed" : "pointer" }}
			>
				<Button
					icon={<UploadOutlined />}
					size={size}
					disabled={isDisabled || readonly}
				>
					{placeholder}
				</Button>
			</Upload>

			{uploadProgress > 0 && uploadProgress < 100 && (
				<Progress percent={uploadProgress} />
			)}

			{fileList.length >= 10 && (
				<FileDetails>
					<div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8, marginTop: 10 }}>
						<FileOutlined style={{ fontSize: 32, color: "#595959" }} />
						<Typography.Text strong>{fileList.length} dosya yüklendi</Typography.Text>
					</div>
					<Button
						icon={<DeleteOutlined />}
						type="primary"
						danger
						onClick={handleRemoveAll}
						style={{ marginTop: "auto" }}
					>
						Tümünü Sil
					</Button>
				</FileDetails>
			)}

			{fileList.length > 0 && fileList.length < 10 && (
				<>
					{fileList.map((fileInfo) => (
						<FileDetails key={fileInfo.name}>
							{fileInfo.type.startsWith("image/") ? (
								<FileImage src={fileInfo.url as string} alt={fileInfo.name} />
							) : (
								<div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 10 }}>
									<FileOutlined style={{ fontSize: 24, color: "#595959" }} />
									<Typography.Text ellipsis style={{ maxWidth: 200 }}>{fileInfo.name}</Typography.Text>
								</div>
							)}
							<Button
								icon={<DeleteOutlined />}
								type="primary"
								danger
								onClick={() => handleRemove(fileInfo.name)}
								style={{ marginTop: "auto" }}
							>
								Dosyayı Sil
							</Button>
						</FileDetails>
					))}
				</>
			)}
		</UploadContainer>
	);
};

export default FileUploadComponent;
